import { useTracking } from 'react-tracking';
import Media from 'react-media';

import {
  Text,
  Heading,
  LoadingSpinner,
  Alert,
  useMount,
  useTheme,
} from '@simplywallst/ui-core';

import type { Portfolio } from '@/hooks/portfolio/usePortfolio';
import { useUserAgent } from '@simplywallst/hooks/useUserAgent';

import { HoldingsTableLoading } from '../../../../components/HoldingsTable';
import { PortfolioSettings } from '../PortfolioSettings';
import { PortfolioPageHeader } from '../../../../components/PortfolioPageHeader';
import { PortfolioOverviewLoadingState } from '../../../../components/PortfolioOverview';

import { TableHeader } from './styled';

type Props = {
  portfolio: Portfolio;
};

const ImportingState = ({ portfolio }: Props) => {
  const theme = useTheme();
  const { isMobile, isTablet, isDesktop } = useUserAgent();
  const { Track, trackEvent } = useTracking({
    type: 'track',
    modifier: 'importingState',
  });

  useMount(() => {
    trackEvent({ action: 'landed' });
  });

  return (
    <Track>
      <div className="mt-x2 md:my-x2">
        <PortfolioPageHeader portfolio={portfolio}>
          <Media
            defaultMatches={isMobile || isTablet}
            query={{ maxWidth: theme.mdMinRaw }}
          >
            <PortfolioSettings portfolio={portfolio} />
          </Media>
          <div className="grid grid-cols-[max-content_auto] items-center gap-x2">
            <div className="grid grid-cols-[max-content_auto] items-center gap-x1">
              <Text typography="tiny" color="whiteRGBA" opacity={0.3}>
                Updating
              </Text>
              <LoadingSpinner light />
            </div>
            <Media
              defaultMatches={isDesktop}
              query={{ minWidth: theme.mdMinRaw }}
            >
              <PortfolioSettings portfolio={portfolio} />
            </Media>
          </div>
        </PortfolioPageHeader>
        <section>
          <div className="m-x2 lg:mx-x0 lg:mb-x3">
            <Alert styleType="loading" data-cy-id="alert-resyncing-message">
              Your portfolio data is being imported. This might take a few
              minutes. Please check back in later.
            </Alert>
          </div>
          <PortfolioOverviewLoadingState />
        </section>
        <section>
          <TableHeader>
            <Heading as="h2" typography="baseStrong">
              Holdings
            </Heading>
          </TableHeader>
          <HoldingsTableLoading />
        </section>
      </div>
    </Track>
  );
};

export default ImportingState;
